import Radium from 'radium';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { semanticColors } from '../../../Globals/styles';
import { httpGet, httpPut, httpPost } from '../../../Util/http';
import Dailies from './dailiesList'


class DepartmentDailyreports extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Dailies: [],
            executed: false
        }
    }
    componentDidMount() {
        setTimeout(() => {
            let _url = process.env.REACT_APP_webApiEndPoint + 'api/department/' + this.props.departmentId + '/dailies?skip=0&take=50';
            httpGet(_url)
                .then(resp => resp.json())
                .then(resp => this.setState({
                    Dailies: resp.dailyreports
                }))
        }, 400)
    }

    attemptDailyReportToggleApproved = (dailyReportIndex, dailyReportId, approved) => {
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/approve';
        httpPut(_url, { approved: approved, id: dailyReportId })
            .then(() => {
                let dailies = this.state.Dailies
                let dailyreport = dailies[dailyReportIndex];
                dailyreport.approved = approved
                this.setState({
                    Dailies: dailies
                })
            })
            .catch(() => {
            })
    }

    attemptDailyReportToggleInvoiced = (dailyReportIndex, dailyReportId, invoiced) => {
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/invoiced';
        httpPut(_url, { invoiced: invoiced, id: dailyReportId })
            .then(() => {
                let dailies = this.state.Dailies
                let dailyreport = dailies[dailyReportIndex];
                dailyreport.invoiced = invoiced
                this.setState({
                    Dailies: dailies
                })
            })
            .catch(() => {
            })
    }

    render() {
        return (
            <div>
                <Dailies
                    dailyReports={this.state.Dailies}
                    workplaces={this.props.workplaces}
                    toggleApproved={(dailyReportIndex, dailyReportId, approved) => {
                        if (this.props.userCanEdit) {
                            this.attemptDailyReportToggleApproved(dailyReportIndex, dailyReportId, approved)
                        }
                    }}
                    toggleInvoiced={(dailyReportIndex, dailyReportId, invoiced) => {
                        if (this.props.userCanEdit) {
                            this.attemptDailyReportToggleInvoiced(dailyReportIndex, dailyReportId, invoiced)
                        }
                    }}
                    goToDailyReport={this.props.goToDailyReport}
                    moreDailies={(length) => {
                        if (!this.state.executed) {
                            this.setState({
                                executed: true
                            })
                            setTimeout(() => {
                                let _url = process.env.REACT_APP_webApiEndPoint + 'api/department/' + this.props.departmentId + '/dailies?skip=' + length + '&take=100';
                                httpGet(_url)
                                    .then(resp => resp.json())
                                    .then(resp => {
                                        if (resp.dailyreports.length > 0) {
                                            let dail = this.state.Dailies;
                                            let conced = dail.concat(resp.dailyreports)
                                            this.setState({
                                                Dailies: conced,
                                                prevLength: length,
                                                executed: false
                                            })
                                        }
                                    })
                            }, 100)
                        }
                    }
                    }
                />
            </div>
        );
    }
}
var styles = {

}

export default Radium(DepartmentDailyreports)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/DepartmentDailyreports/index.js